import { Component, Input, inject, SimpleChanges, OnChanges } from '@angular/core';
import { FormatWidth, getLocaleDateFormat } from '@angular/common';
import { IPaymentDetailResponse } from '@app/services/bavel-payment-manager-client.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-detail-crypta-info',
  templateUrl: './payment-detail-crypta-info.component.html',
  styleUrls: ['./payment-detail-crypta-info.component.scss'],
  standalone: false
})
export class PaymentDetailCryptaInfoComponent implements OnChanges {
  @Input() public editMode = false;
  @Input() public paymentDetail = {} as IPaymentDetailResponse;
  public effectiveDateRange: Date[] = [];

  private translateService: TranslateService = inject(TranslateService);

  public ngOnChanges(changes: SimpleChanges): void {
    this.effectiveDateRange = [
      changes.paymentDetail.currentValue.effectiveMinDate,
      changes.paymentDetail.currentValue.effectiveMaxDate
    ];
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  public dateRangeSelected(dateSelector: any): void {
    if (dateSelector.inputFieldValue && dateSelector.inputFieldValue.includes(' - ')) {
      this.paymentDetail.effectiveMinDate = new Date(dateSelector.value[0]);
      this.paymentDetail.effectiveMaxDate = new Date(dateSelector.value[1]);
    } else {
      this.paymentDetail.effectiveMinDate = undefined;
      this.paymentDetail.effectiveMaxDate = undefined;
      dateSelector.inputFieldValue = null;
    }
  }

  public getDateFormatForCalendar(): string {
    return getLocaleDateFormat(this.translateService.currentLang, FormatWidth.Short).toLowerCase().replace('yy', 'y');
  }
}
